/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use DS Form instead
 */
import { Flex, Spacing } from '@billy/design-system'
import React, { ReactNode } from 'react'

import { deprecatedComponentInfo } from '../../../utils/deprecatedComponentInfo'
import { ConnectForm, ConnectFormType } from '../ConnectForm'
import { ErrorMessage } from '../ErrorMessage'
import { FormLabel } from '../FormLabel'
import { InputProps } from '../Input'
import * as Styled from './styles'

deprecatedComponentInfo('FormGroup', 'ControlledFormGroup')

export type FormGroupProps = {
  addLabel?: string
  children: React.ReactElement<InputProps>[] // Limit children to valid inputs
  className?: string
  id?: string
  label?: ReactNode
  horizontal?: boolean
  silent?: boolean
}

export const FormGroup = React.forwardRef<HTMLDivElement, FormGroupProps>(
  ({ children, label, horizontal, silent, className, id = '0' }, ref) => {
    const names = [] as string[]
    let required = false
    React.Children.forEach(children, (child: React.ReactElement<InputProps>) => {
      child.props.name && names.push(child.props.name)
      required = required || !!(child.props.required || child.props.options?.required)
    })

    return (
      <ConnectForm>
        {({ formState }: ConnectFormType) => {
          const errors = formState?.errors || {}

          return (
            <div ref={ref} id={id} className={className}>
              {label && <FormLabel required={required}>{label}</FormLabel>}

              <Flex key={id} gap={Spacing.S8}>
                <Styled.FormItemWrapper isHorizontal={horizontal}>
                  {React.Children.map(
                    children as React.ReactElement<InputProps>[],
                    (child: React.ReactElement<InputProps>): JSX.Element | null =>
                      React.isValidElement(child)
                        ? React.cloneElement(child, {
                            silent,
                            name: id !== '0' ? `${child.props.name}-${id}` : child.props.name,
                          })
                        : null,
                  )}
                </Styled.FormItemWrapper>
              </Flex>
              {names.map((name) => errors[name] && <ErrorMessage key={name} error={errors[name]} />)}
            </div>
          )
        }}
      </ConnectForm>
    )
  },
)
